import PropTypes from 'prop-types';
import {Component} from 'react';
import {Segment} from 'semantic-ui-react';
import decreaseIcon from '../images/down_red.svg';
import increaseIcon from '../images/up_green.svg';
import Formatter from '../lib/Formatter';
import ChartViewer from './ChartViewer';
import './CustomiseRentalMarketTrends.scss';
import OptionalTitle from './OptionalTitle';

export default class CustomiseRentalMarketTrends extends Component{

  static propTypes = {
    marketTrendsType: PropTypes.oneOf(['recent', 'longTerm']).isRequired,
    section: PropTypes.object.isRequired,
    marketTrendsData: PropTypes.object.isRequired,
    onUpdateSectionValue: PropTypes.func.isRequired,
  };

  showRentalYieldColumn = (medianAskingRentData) => {
    return medianAskingRentData?.filter(v => v.rentalYieldObservation !== undefined).length >= 10;
  };

  createMedianAskingRentTable = (medianAskingRentData) => {
    return (
      <div className="median-asking-rent-table">
        { this.createColumn('period', 'PERIOD', medianAskingRentData, 'period') }
        { this.createPriceColumn('asking-rent', 'ASKING RENT', medianAskingRentData, 'askingRent') }
        { this.createPercentColumn('growth', 'CHANGE', medianAskingRentData, 'growth') }
        { this.createGrossRentalColumn('grossRentalYield', 'GROSS RENTAL YIELD', medianAskingRentData, 'grossRentalYield') }
        { this.showRentalYieldColumn(medianAskingRentData) && this.createColumn('rentalYieldObservation', 'RENTAL OBSERVATIONS', medianAskingRentData, 'rentalYieldObservation') }
      </div>
    );
  };

  createColumn = (className, header, data, key) => {
    return (
      <div className={`${className} column`}>
        <div className="column-subheader">{header}</div>
        {data && data.map((v, idx) => {
          return <div className="row" key={idx}>{v !== null && v[key] ? v[key] : '-'}</div>;
        })}
      </div>
    );
  };

  createPriceColumn = (className, header, data, key) => {
    return (
      <div className={`${className} column`}>
        <div className="column-subheader">{header}</div>
        {data && data.map((v, idx) => {
          return <div className="row" key={idx}>{v !== null && v[key] ? Formatter.currency(v[key]) : '-'}</div>;
        })}
      </div>
    );
  };

  createPercentColumn = (className, header, data, key) => {
    return (
      <div className={`${className} column`}>
        <div className="column-subheader">{header}</div>
        {data && data.map((v, idx) => {
          return (<div className="percent row" key={idx}>
            <div className="percent-col">
              {v && v[key] && v[key] - 1 !== 0 ? Formatter.percentage(v[key] - 1) : (v[key]) ? '0.0%' : '-'}
            </div>
            {/* the 1.0005 and 0.9995 are the bounds where we consider it flat growth */}
            <div className="percent-icon">
              {v !== null && v[key] && (v[key] >= 1.0005 || v[key] < 0.9995) ? (
               <img src={v[key] > 1 ? increaseIcon : decreaseIcon} alt=""/>
              ) : null}
            </div>
          </div>);
        })}
      </div>
    );
  };

  createGrossRentalColumn = (className, header, data, key) => {
    return (
      <div className={`${className} column`}>
        <div className="column-subheader">{header}</div>
        {data && data.map((v, idx) => {
          return (<div className="row" key={idx}>
            {v && v[key] && v[key] !== 0 ? Formatter.percentage(v[key]) : '-'}
          </div>);
        })}
      </div>
    );
  };

  isMarketTrendsSectionEnabled = (section, marketTrendsType) => {
    return section.sectionData[`${ marketTrendsType }MarketTrends_isEnabled`] === 'true';
  };

  render() {
    const {marketTrendsData, marketTrendsType, section, onUpdateSectionValue} = this.props;
    const enableMarketTrendsSection =this.isMarketTrendsSectionEnabled(section, marketTrendsType);
    return (
      <Segment className="rental-market-trends" style={ {padding: '30px'} }>
        <OptionalTitle
          className="section-title"
          onUpdateData={ ({title, isEnabled}) => {
            if (title !== undefined) {
              onUpdateSectionValue((title || section.defaultTitles[`${marketTrendsType}MarketTrends`]), `sectionData.${marketTrendsType}MarketTrendsTitle`);
            }
            if (isEnabled !== undefined ) {
              onUpdateSectionValue(`${ isEnabled }`, `sectionData.${marketTrendsType}MarketTrends_isEnabled`);
            }
          }}
          title={ section.sectionData[`${marketTrendsType}MarketTrendsTitle`] || section.defaultTitles[`${marketTrendsType}MarketTrends`]}
          isEnabled={enableMarketTrendsSection}/>

        <ChartViewer
          base64EncodedPngChartImage={marketTrendsData.medianAskingRentChartImage}
          altText="Median Asking Rent Chart"
          errorMessage="Median Asking Rent chart is not available because there is not enough data for a statistically reliable output"
        />
        <ChartViewer
          base64EncodedPngChartImage={marketTrendsData.grossRentalYieldChartImage}
          altText="Gross Rental Yield Chart"
          errorMessage="Gross Rental Yield chart is not available because there is not enough data for a statistically reliable output"
        />
        { marketTrendsData.medianAskingRentData && this.createMedianAskingRentTable(marketTrendsData.medianAskingRentData) }

      </Segment>
    );
  }
}